module.exports = __webpack_public_path__ + "static/img/apple.e0f090a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/apple.svg
// module id = J51o
// module chunks = 35